import { PieceIcons, PieceNames } from "../models/Piece/types";

export const pieces = [
  { name: PieceNames.QUEEN, icon: PieceIcons.QUEEN },
  { name: PieceNames.ROOK, icon: PieceIcons.ROOK },
  { name: PieceNames.BISHOP, icon: PieceIcons.BISHOP },
  { name: PieceNames.KNIGHT, icon: PieceIcons.KNIGHT },
];
